import { Ad, IAd } from '.'

export enum AdEvents {
    DISPLAY = 'adDisplay',
    SLOT_ADDED = 'adSlotAdded',
    STICKY_AD_CLOSED = 'stickyAdClosedEvent'
}

export interface IAdEvent extends CustomEvent<IAd> {
    detail: Ad
}

export interface IAdSlotsAddedEvent extends CustomEvent {
    detail: {
      el: IAd[]
    }
}
